import * as React from 'react';
import clsx from 'clsx';
import themePrimary from '../../styles/themePrimary';
import { useMediaQuery, makeStyles, Typography, Tooltip, ClickAwayListener } from '@material-ui/core';
import TipSelector, { TipButtonClickHandler, TipSelectorProps } from './TipSelector';
import ManualTipSelector, { ManualTipChangeHandler, ManualTipSelectorProps } from './ManualTipSelector';
import { CheckTotal } from '../../models/payment/CheckTotal';
import { UserStateContext } from '../../providers/UserStateContextProvider';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import { String_PaymentTip_SubTotalLabel, String_PaymentTip_TaxAndServiceChargeLabel, String_PaymentTip_TotalLabel, 
    String_Check_TaxesAndFeesToolTip } from '../../utilities/StringHelper';
import { ElementDimensions } from '../../styles/ElementDimensions';
import InfoIcon from '@material-ui/icons/Info';

const useStyles = makeStyles({
    infoIcon: {
        width: '20px',
        height: '20px',
        marginTop: 'auto',
        marginBottom: 'auto',
        color: themePrimary.palette.primary.contrastText,
    },
    infoIconContainer: {
        marginLeft: ElementDimensions.margin5 + 'px',
        marginTop: 'auto',
        marginBottom: 'auto',
        borderRadius: '50px',
        display: 'flex',
        backgroundColor: themePrimary.palette.secondary.contrastText,
    },
    remainingBalanceText: {
        fontWeight: 'bold',
    },
    root: {
        overflowY: 'scroll',
    },
    summaryGrid: {
        display: 'grid',
        gridGap: '0px',
        gridTemplateColumns: '75% 25%',
        marginLeft: ElementDimensions.margin10 + 'px',
        marginRight: ElementDimensions.margin10 + 'px',
        width: '100%',
    },
    summaryGridContainer: {
        textAlign: 'center',
        display: 'flex',
        paddingTop: ElementDimensions.padding10 + 'px',
        paddingBottom: ElementDimensions.padding10 + 'px',
    },
    summaryGridCellLabelLeft: {
        textAlign: 'left',
    },
    summaryGridCellLabelRight: {
        textAlign: 'right',
    },
    summaryText: {
        color: themePrimary.palette.secondary.contrastText,
        fontSize: '1.2rem',
        fontFamily: 'LeagueSpartan-Regular !important',
    },
    summaryTextAmount: {
        color: themePrimary.palette.secondary.contrastText,
        fontSize: '1.2rem',
    },
    taxAndServiceChargeText: {
        display: 'flex',
    },
});

export interface PaymentTipProps {
    checkTotal: CheckTotal | null,
    onTipClickHandler: TipButtonClickHandler,
    onManualTipChangeHandler: ManualTipChangeHandler,
}

export default function PaymentTip(props: PaymentTipProps) {
    const {checkTotal, onTipClickHandler, onManualTipChangeHandler} = props;
    const isPortrait = true;
    const [toolTipOpen, setToolTipOpen] = React.useState<boolean>(false);
    const userState = React.useContext(UserStateContext);
    const checkOutState = React.useContext(CheckOutStateContext);
    const classes = useStyles({ primary_main_color: checkOutState.state.skin.primary_main_color, 
        primary_light_color: checkOutState.state.skin.primary_light_color, primary_dark_color: checkOutState.state.skin.primary_dark_color });

    const handleManualTipButtonClick = (event: React.MouseEvent<HTMLElement> | undefined, tipValue: number, isManual: boolean) => {
        onTipClickHandler(event, tipValue, isManual);
    }

    const handleTipButtonClick = (event: React.MouseEvent<HTMLElement> | undefined, tipValue: number, isManual: boolean) => {
        onTipClickHandler(event, tipValue, isManual);
    }

    const handleManualTipChange: ManualTipChangeHandler = (tipValue: number) => {
        onManualTipChangeHandler(tipValue);
    }

    const manualTipProps: ManualTipSelectorProps = {
        checkTotal: checkTotal,
        onClickHandler: handleManualTipButtonClick,
        onManualTipHandler: handleManualTipChange,
    }

    const tipProps: TipSelectorProps = {
        checkTotal: checkTotal,
        onClickHandler: handleTipButtonClick,
    }

    const handleTooltipClose = () => {
        setTimeout(() => {setToolTipOpen(false);}, 2000);
    };
    
    const handleTooltipOpen = () => {
        setToolTipOpen(true);
    };

    return (
        <div className={classes.root}>
            
            {(checkTotal !== null && checkTotal !== undefined) &&
                <ManualTipSelector 
                    checkTotal={manualTipProps.checkTotal}
                    onClickHandler={manualTipProps.onClickHandler} 
                    onManualTipHandler={manualTipProps.onManualTipHandler} />
            }
            
        </div>
    );
}